"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../assets/PPTooltip.css");
var PPTooltip = function (props) {
    var _a = (0, react_1.useState)(false), visible = _a[0], setVisible = _a[1];
    var _b = (0, react_1.useState)(0), tooltipWidth = _b[0], setTooltipWidth = _b[1];
    var _c = (0, react_1.useState)(0), top = _c[0], setTop = _c[1];
    var _d = (0, react_1.useState)(0), left = _d[0], setLeft = _d[1];
    var _e = (0, react_1.useState)(0), height = _e[0], setHeight = _e[1];
    var onScroll = function () {
        setVisible(false);
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener("scroll", onScroll, true);
        return function () {
            window.removeEventListener("scroll", onScroll, true);
        };
    }, []);
    var handleHover = function (event) {
        if (event.target.parentElement.className === "pp-tooltip") {
            var _height = event.target.parentElement.offsetHeight;
            var _top = event.target.parentElement.getBoundingClientRect().top;
            setTop(!props.top ? _top : _top - height);
            setHeight(_height);
        }
        setVisible(true);
    };
    var onRef = function (event) {
        if (event) {
            try {
                setLeft(event.getBoundingClientRect().left);
            }
            catch (error) { }
            event.offsetWidth && setTooltipWidth(event.offsetWidth);
        }
    };
    return (react_1.default.createElement("div", { className: "pp-tooltip", ref: onRef, onClick: function () { return (!props.trigger || props.trigger === 'click') && setVisible(!visible); }, onMouseOver: function (event) { return props.trigger === 'hover' && handleHover(event); }, onMouseLeave: function () { return setVisible(false); } },
        !props.top && props.children,
        visible && props.content &&
            react_1.default.createElement("div", { className: "body".concat(props.top ? ' top' : '').concat(props.position ? ' ' + props.position : ''), style: {
                    width: tooltipWidth + 'px',
                    top: (top + height) > 0 ? top + height : 'auto',
                    left: left
                } },
                react_1.default.createElement("i", { className: "ppi ppi-chevron-up-alt" }),
                react_1.default.createElement("div", { className: "main".concat(props.position ? ' ' + props.position : '') },
                    react_1.default.createElement("div", { className: "content" }, props.content))),
        props.top && props.children));
};
exports.default = PPTooltip;
